/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Agents_Steps_BodyInputs */

const en_svc_agents_steps_body = /** @type {(inputs: Svc_Agents_Steps_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We start from one recurring task and a few real examples, not from a platform.`)
};

const lv_svc_agents_steps_body = /** @type {(inputs: Svc_Agents_Steps_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sākam no viena atkārtota uzdevuma un dažiem reāliem piemēriem, nevis no platformas.`)
};

/**
* | output |
* | --- |
* | "We start from one recurring task and a few real examples, not from a platform." |
*
* @param {Svc_Agents_Steps_BodyInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_agents_steps_body = /** @type {((inputs?: Svc_Agents_Steps_BodyInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Agents_Steps_BodyInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_agents_steps_body(inputs)
	return en_svc_agents_steps_body(inputs)
});